// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#notice[data-v-a69f9d7e] {\n  opacity: 0;\n  transition: opacity 600ms ease;\n  pointer-events: none;\n}\n#notice.copied[data-v-a69f9d7e] {\n  opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
